import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as ARInvoiceStore from '../../store/ARInvoice';
import * as ARInvoiceMdls from '../../models/ArInvoiceModel';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as PDFReports from '../../store/PDFReports';

type MyProps =
    { ARInvoiceList: ARInvoiceMdls.ArInvoiceModelList, SessionState: SessionMdl.SessionModel } & typeof ARInvoiceStore.actionCreators;

const OpenInvoices: React.FunctionComponent<MyProps> = (props: MyProps) => {

    useEffect(() => {
        props.loadInvoices(false);
    }, []);

    const [localbalanceDue, updateBalanceDueState] = useState<number>(0);
    const [totalbalanceDue, updateTotalDueState] = useState<number>(0);
    const [programmFeeAmt, updateProgramFee] = useState<number>(0);

    //Updale BalanceDue when Props Change
    useEffect(() => {
        const AmountBalance = props.ARInvoiceList.items.reduce((mySum, x) => mySum + (x.isSelectedToPay ? x.total : 0), 0);
        updateTotalDueState(AmountBalance);
        const Fee = props.ARInvoiceList.items.reduce((mySum, x) => mySum + (x.isSelectedToPay ? x.programFee : 0), 0);
        updateProgramFee(Fee);
        updateBalanceDueState(AmountBalance+Fee);
        //const TotalBalance = props.ARInvoiceList.items.reduce((mySum, x) => mySum + x.total, 0);
        
    }, [props]);

    const checkBoxHandler = (myVal: ARInvoiceMdls.ArInvoiceModel, e: React.ChangeEvent<HTMLInputElement>) => {

        myVal.isSelectedToPay = e.target.checked;
        props.updateIsSelectedValue(myVal);
    };

    const showComments = (item: ARInvoiceMdls.ArInvoiceModel) => {
        updateComment(item.invoiceComments != null ? item.invoiceComments : '');
        updateTitle(item.invoiceNumber);
        toggle();
    }

    const [commentToDisplay, updateComment] = useState('');
    const [titleToDisplay, updateTitle] = useState('');

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const handleClick = (companyCode: string, invoiceNum: string) => {
        PDFReports.retrieveInvoicePDF(companyCode, invoiceNum);
    };

    const creaditCardDiv = (ccEnabled: boolean, localBalance: number, ccMode: string) =>
    {
        if (ccEnabled && localbalanceDue != 0) {
  
            switch ((ccMode||'').toUpperCase()) {

                case "FULLSTEAM":
                    return (<Link to="FullSteamPay">  <Button color="success">Pay</Button></Link>);
                case "MXMERCHANT":
                default:
                    return (<Link to="MXMerchant">  <Button color="success">Pay</Button></Link>);
            }

        }
        return "";            
    };

    return (
        <>
            <Container fluid={true}>
                <LoadingIcon loading={props.ARInvoiceList.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
                <Card>
                    <CardHeader>
                        <Row>
                            <Col className="right-align" style={{ marginTop: "10px" }}>
                                <SaLabel Text="Invoice Total" />
                                <SaCurrency Amount={totalbalanceDue} />                              
                            </Col>
                            {props.SessionState.TransactionFeeEnabled &&
                                <Col className="right-align" style={{ marginTop: "10px" }}>
                                    {props.SessionState.SelectedAR.creditCardEnabled &&
                                    <>
                                        <SaLabel Text={props.SessionState.TransactionFeeLabel + "(" + props.SessionState.TransactionFeePerc + "%)"} />
                                    <SaCurrency Amount={programmFeeAmt} />
                                        </>
                                    }
                                </Col>
                            }
                            <Col className="right-align" style={{ marginTop: "10px" }}>
                                {props.SessionState.SelectedAR.creditCardEnabled &&
                                    <>
                                        <SaLabel Text="Total To Pay" />
                                        <SaCurrency Amount={localbalanceDue} />
                                    </>
                                }
                            </Col>
                            <Col className="text-right" style={{ marginTop: "10px" }}>
                                {creaditCardDiv(props.SessionState.SelectedAR.creditCardEnabled, localbalanceDue, props.SessionState.SelectedAR.ccMode )}
                                {localbalanceDue == 0 && <span style={{ fontSize: "0.7em" }}>Please select invoice(s) to pay</span>}

                            </Col>
                        </Row>

                    </CardHeader>
                    <div style={{ overflowX: "scroll" }}>
                        <Table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Invoice</th>
                                    <th>Date</th>
                                    <th style={{ textAlign: "right" }}>Invoice Total</th>
                                    <th style={{ textAlign: "right" }}>Balance Due</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.ARInvoiceList.items.map((item, index) =>

                                    <tr key={index}>
                                        <td>{props.SessionState.SelectedAR.creditCardEnabled && <input type={"checkbox"} checked={item.isSelectedToPay} onChange={(e) => checkBoxHandler(item, e)} />}</td>
                                        <th>
                                            {item.invoiceNumber.slice(-1) == "S" ?
                                                <span className='callHistoryInvoiceLink' onClick={() => handleClick(props.SessionState.SelectedAR.companyCode, item.invoiceNumber)}>
                                                    {item.invoiceNumber}
                                                </span>
                                                :
                                                item.invoiceNumber
                                                } &nbsp;


                                            {item.invoiceComments &&
                                                <FontAwesomeIcon style={{ cursor: "pointer" }} onClick={() => showComments(item)} icon={faCommentDots} className="commentsBtn" />
                                            }
                                        </th>
                                        <td><SaDate Value={item.invoiceDate} /></td>
                                        <td style={{ textAlign: "right" }}><SaCurrency Amount={item.total} /></td>
                                        <td style={{ textAlign: "right" }}><SaCurrency Amount={item.balanceDue} /></td>
                                    </tr>

                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card>
            </Container>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>{titleToDisplay}</ModalHeader>
                <ModalBody>
                    {commentToDisplay}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default connect((state: ApplicationState) =>
    ({ ...{ ARInvoiceList: state.openInvoicesState, SessionState: state.sessionState } }),
    ARInvoiceStore.actionCreators)(OpenInvoices as any);